//
//   _______  ________________  _____
//  / ___/ / / / ___/ ___/ __ \/ ___/
// / /__/ /_/ / /  (__  ) /_/ / /
// \___/\__,_/_/  /____/\____/_/

/* global */

// import debounce from 'javascript-debounce';
import { splitInner, splitHTML } from './splitting-setup';

const setupCursor = () => {
  console.log('{ setupCursor }');

  const cursor = document.getElementById('cursor');
  const cursorCircle = cursor.querySelectorAll('.cursor-circle')[0];
  const cursorArrow = cursor.querySelectorAll('.cursor__arrow')[0];
  let intervalID;

  // ----------------------------------------------------------------------------
  //
  // Cursor position
  //
  // ----------------------------------------------------------------------------
  const mouseCursor = (e) => {
    // reveal cursor
    if (cursor.classList.contains('hidden')) {
      cursor.classList.remove('hidden');
    }

    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';

    requestAnimationFrame(mouseCursor);
  };

  // requestAnimationFrame(mouseCursor);

  // ----------------------------------------------------------------------------
  // Mouse mouse event listener
  // ----------------------------------------------------------------------------
  window.addEventListener('mousemove', mouseCursor);

  $(document)
    // ----------------------------------------------------------------------------
    // Mouseover element with data-cursor
    // ----------------------------------------------------------------------------
    .on('mouseover', '[data-cursor]', function () {
      // clear any current timers
      clearTimeout(intervalID);

      // console.log( 'e: %o', e );
      const cursorText = this.getAttribute('data-cursor');
      const cursorColor = this.getAttribute('data-cursor-color');

      // Apply Splitting on cursor text
      $(cursorCircle).html(splitHTML(cursorText));
      // wrap splitting words with word__inner
      splitInner($(cursorCircle).find('.word'));
      // remove / add class to re-trigger show animation
      $(cursorCircle)
        .find('.splitting')
        .hide(0)
        .removeClass('show')
        .show(0)
        .addClass('show');

      // ----------------------------------------------------------------------------
      // If inactive/default state
      // ----------------------------------------------------------------------------
      if (!cursor.classList.contains('active')) {
        cursor.classList.add('active');
      } else {
        // already scaled up
        // check for data-cursor-color - change bg color if different
        // hide current text, reveal new text
      }

      // check for data-cursor-color - change bg color
      if (null === cursorColor && cursor.classList.contains('colored')) {
        cursorResetColor();
      } else if (null !== cursorColor) {
        cursor.classList.add('colored');

        $(cursorCircle).css({
          backgroundColor: cursorColor
        });
      }
    })
    // ----------------------------------------------------------------------------
    // Mouseout element with data-cursor
    // ----------------------------------------------------------------------------
    .on('mouseout', '[data-cursor]', function () {
      // console.log( 'mouseexit' );

      // reverse text animation
      $(cursorCircle).find('.splitting').removeClass('show');

      // clear any current timers
      clearTimeout(intervalID);

      // wait 500ms
      intervalID = setTimeout(function () {
        cursor.classList.remove('active');

        // change bg color
        if (cursor.classList.contains('colored')) {
          cursorResetColor();
        }

        // remove current text
        $(cursorCircle).html('');
      }, 250);
    })
    // ----------------------------------------------------------------------------
    // Mouseover - slide next/prev
    // ----------------------------------------------------------------------------
    .on('mouseover', '.js-slide-link', function () {
      // console.log( 'mouseover: js-slide-link' );

      if ($(this).hasClass('slider-controls__left')) {
        // flip cursor arrow
        $(cursorArrow).addClass('left');
      } else {
        // reset arrow direction
        $(cursorArrow).removeClass('left');
      }

      // ----------------------------------------------------------------------------
      // If inactive/default state
      // ----------------------------------------------------------------------------
      if (!cursor.classList.contains('active')) {
        cursor.classList.add('active');

        // check for data-cursor-color - change bg color
        cursorResetColor();

        $(cursorArrow).removeClass('hidden');
      } else {
        // already scaled up
        // check for data-cursor-color - change bg color if different
        // hide current text, reveal new text
      }
    })
    // ----------------------------------------------------------------------------
    // Mouseout - slide next/prev
    // ----------------------------------------------------------------------------
    .on('mouseout', '.js-slide-link', function () {
      // console.log( 'mouseout: js-slide-link' );

      cursor.classList.remove('active');

      // hide current text
      $(cursorArrow).addClass('hidden');
    });

  // ----------------------------------------------------------------------------
  //
  // Cursor reset color
  //
  // ----------------------------------------------------------------------------
  function cursorResetColor() {
    cursor.classList.remove('colored');
    $(cursorCircle).attr('style', '');
  }
}; // END: setupCursor

// ----------------------------------------------------------------------------
//
// Data-Cursor injection
//
// ----------------------------------------------------------------------------
const setupCursorText = () => {
  const anchors = $('.user-content a');
  let cursorColor;

  $.each(anchors, (i, el) => {
    // Check if has title property
    if ($(el).prop('title')) {
      $(el).attr('data-cursor', $(el).prop('title'));

      // If element doesn't have a data-cursor attribute already
    } else if (!$(el).attr('data-cursor')) {
      $(el).attr('data-cursor', $(el)[0].text);
    }

    // check if anchor within project coloured section
    cursorColor = anchorParentCheck(
      $(el),
      '.home-project',
      '.home-project__link'
    );

    if (cursorColor) {
      $(el).attr('data-cursor-color', cursorColor);
    }
  });
};

// ----------------------------------------------------------------------------
//
// Utility function to check for given parent - if found - get cursor color from given element
//
// ----------------------------------------------------------------------------
function anchorParentCheck(child, parent, source) {
  let result = false;

  if (child.parents(parent).length) {
    result = $(child.parents(parent)[0]).find(source).attr('data-cursor-color');
  }

  return result;
}

export { setupCursor };
export { setupCursorText };



// WEBPACK FOOTER //
// ./scripts/modules/cursor.js